import { AppState } from "@Safemate/Store/types";

export const selectFilter = ({ txLog: { transaction: { filter } } }: AppState) => filter;
export const selectDates = ({txLog: { transaction: { toDate, fromDate } }}: AppState) => { return {fromDate, toDate}}
export const selectDevice = ({txLog: { device: { device }}}: AppState) => device;
export const selectTransactions = ({txLog: { transaction: { transactions } } }: AppState) => transactions;
export const selectPage = ({txLog: {transaction: {page}}}: AppState) => page
export const selectLastUpdate = ({txLog: { transaction: { lastUpdate } }}: AppState) => lastUpdate;